import { Checkbox, FormControlLabel, ListItem } from '@mui/material';
import React from 'react';
import { mantyIntegrations } from 'routes/IntegrationsList/fullIntegrationList';
import { handleCheckboxChange } from '../helpers/onChange';

const IntegrationCheckbox = ({
    software,
    newSoftwares,
    setNewSoftwares,
}: {
    software: (typeof mantyIntegrations)[number];
    newSoftwares: string[];
    setNewSoftwares: (newSoftwares: string[]) => void;
}) => (
    <ListItem>
        <FormControlLabel
            label={software.title}
            control={
                <Checkbox
                    checked={newSoftwares.includes(software.software)}
                    onChange={() =>
                        handleCheckboxChange(
                            software.software,
                            newSoftwares,
                            setNewSoftwares,
                        )
                    }
                />
            }
        />
    </ListItem>
);

export default React.memo(IntegrationCheckbox);
